import {
	useTypedLazyQuery,
	useTypedMutation,
	useTypedQuery,
} from "@/services/graphApi";
import { $, ValueTypes, ZeusSelect } from "@/services/graphApi/graphql-zeus";

export const useUnityAccessesQuery = () =>
	useTypedQuery(
		{
			unityAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				UnityAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useUnityAccessesLazyQuery = () =>
	useTypedLazyQuery(
		{
			unityAccesses: [
				{
					where: {
						organizationAttributes_some: {
							organization: { id: $`organizationId` },
						},
					},
				},
				UnityAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useUnityAccessQuery = () =>
	useTypedLazyQuery(
		{
			unityAccess: [
				{
					where: {
						id: $`id`,
					},
				},
				UnityAccessSelector,
			],
		},
		{
			notifyOnNetworkStatusChange: true,
		}
	);

export const useCreateUnityAccess = () => {
	return useTypedMutation({
		createUnityAccess: [
			{
				data: $`data`,
			},
			UnityAccessSelector,
		],
	});
};
export const useUpdateUnityAccess = () => {
	return useTypedMutation({
		updateUnityAccess: [
			{
				where: $`where`,
				data: $`data`,
			},
			UnityAccessSelector,
		],
	});
};
export const useDeleteUnityAccess = () => {
	return useTypedMutation({
		deleteUnityAccess: [
			{
				where: $`where`,
			},
			UnityAccessSelector,
		],
	});
};

export const UnityAccessSelector = ZeusSelect<ValueTypes["UnityAccess"]>()({
	id: true,
	descriptiveName: true,
	apiKey: true,
	organizationId: true,
	organizationAttributes: [
		{},
		{
			id: true,
			organization: {
				id: true,
				name: true,
			},
			role: true,
		},
	],
});
